import React, {useState} from 'react';
import {useSelector} from "react-redux";
import useAsyncErrorHandler from "./useAsyncErrorHandler";
import useLoading from "./useLoading";
import * as Async from "../features/async";

export default function useRemove(config = { returnInnerLoadingState: false }) {
    const credencial = useSelector(state => state.credencial);
    const setLoading = useLoading();
    const asyncErrorHandler = useAsyncErrorHandler();
    const [innerLoading, setInnerLoading] = useState(false);

    const deleteFunc = (url, onSuccess, finishLoading = true, dataToSend) => {

        config.returnInnerLoadingState ? setInnerLoading(true) : setLoading(true);

        return Async.remove(url, credencial, dataToSend)
            .then(data => {
                onSuccess && onSuccess(data);

                return data;
            })
            .catch(asyncErrorHandler)
            .finally(() => {
                config.returnInnerLoadingState ? setInnerLoading(false) : (finishLoading && setLoading(false));
            });
    }

    return !config.returnInnerLoadingState ? deleteFunc : [deleteFunc, innerLoading];
}